import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useGlobalContext from "../Context/useGlobalContext";
import { makeStyles } from "@material-ui/styles";
import { Theme, Typography } from "@material-ui/core";
import { colors } from "../styles/theme";
import config from "../config.json";
 
export default function TermsAndConditionDialog() {
  const {
    isShowTermsAlert,
    setIsShowTermsAlert,
    setIsAgreedTerms,
    setIsShowForm,
  } = useGlobalContext();

  const styles = useStyles();

  const handleAgree = () => {
    setIsShowTermsAlert(false);
    setIsAgreedTerms(true);
    setIsShowForm(true);
  };

  const handleDisAgree = () => {
    setIsShowTermsAlert(false);
    setIsAgreedTerms(false);
  };

  var link = (
    <a
      href={config.termsAndConditionPath}
      target="_blank"
      className={styles.anchorTag}
    >
      terms and conditions
    </a>
  );
  return (
    <div>
      <Dialog
        open={isShowTermsAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Typography className={styles.headingText}>{config.termsAndConditionText}</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography className={styles.contentText}>
            By clicking "Accept", I acknowledged that I have read and accepted
            the {link} of the agreements
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleDisAgree}
            variant="contained"
            color="primary"
            className={styles.applyBtn}
          >
            Reject
          </Button>
          <Button
            onClick={handleAgree}
            variant="contained"
            color="primary"
            className={styles.applyBtn}
            autoFocus
          >
            Accept
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    applyBtn: {
      fontSize: "12px",
      textTransform: "capitalize",
      marginBottom: '5px'
    },
    headingText: {
      color: colors.colorBorder,
      fontSize: "16px",
    },
    contentText: {
      lineHeight: 1.4,
      fontSize: "14px",
    },
    anchorTag: {
      cursor: "pointer",
    },
  };
});
